import { render } from "./DangCard.vue?vue&type=template&id=e52d593a&scoped=true"
import script from "./DangCard.vue?vue&type=script&lang=js"
export * from "./DangCard.vue?vue&type=script&lang=js"

import "./DangCard.vue?vue&type=style&index=0&id=e52d593a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e52d593a"]])

export default __exports__